import {
  GET_CALL_HOUR_GROUPS,
  GET_CALL_MENU_OPTIONS,
  GET_CALL_MENUS,
  GET_CONTACT_CALLERS,
  DELETE_CONTACT_CALLER,
  GET_TEAMS,
  DELETE_TEAM,
  SAVE_CALL_MENU_OPTION,
  SAVE_CALL_MENU,
  SAVE_CALL_HOUR_GROUP,
  GET_CALL_MENU,
  DELETE_CALL_MENU,
  DELETE_CALL_MENU_OPTION,
  CALL_IN_PROGRESS,
} from './types';
import * as ivrSvc from 'services/ivr.service';

export const getCallMenuOptions = (query) => ({
  type: GET_CALL_MENU_OPTIONS,
  payload: {
    promise: ivrSvc.getCallMenus(query),
  },
});

export const saveCallMenuOption = (data) => ({
  type: SAVE_CALL_MENU_OPTION,
  payload: {
    promise: ivrSvc.saveCallMenuOption(data),
  },
});

export const getCallMenus = (receptionistId) => ({
  type: GET_CALL_MENUS,
  payload: {
    promise: ivrSvc.getCallMenus({ digital_receptionist_id: receptionistId }),
  },
});

export const saveCallMenu = (data) => ({
  type: SAVE_CALL_MENU,
  payload: {
    promise: ivrSvc.saveCallMenu(data),
  },
});

export const getContactCallers = (params) => ({
  type: GET_CONTACT_CALLERS,
  payload: {
    promise: ivrSvc.getCallers(params),
  },
});

export const deleteContactCaller = (hash) => ({
  type: DELETE_CONTACT_CALLER,
  payload: {
    promise: ivrSvc.deleteCaller(hash),
    hash,
  },
});

export const getTeams = (params) => ({
  type: GET_TEAMS,
  payload: {
    promise: ivrSvc.getTeams(params),
  },
});

export const deleteTeam = (hash) => ({
  type: DELETE_TEAM,
  payload: {
    promise: ivrSvc.deleteTeam(hash),
    hash,
  },
});

export const getCallMenu = (callMenuHash) => ({
  type: GET_CALL_MENU,
  payload: {
    promise: ivrSvc.getCallMenu(callMenuHash),
  },
});

export const deleteCallMenu = (callMenuHash) => ({
  type: DELETE_CALL_MENU,
  payload: {
    promise: ivrSvc.deleteCallMenu(callMenuHash),
    hash: callMenuHash,
  },
});

export const deleteCallMenuOption = (callMenuOptionHash) => ({
  type: DELETE_CALL_MENU_OPTION,
  payload: {
    promise: ivrSvc.deleteCallMenuOption(callMenuOptionHash),
    hash: callMenuOptionHash,
  },
});

export const notifyCallInProgress = (data) => ({
  type: CALL_IN_PROGRESS,
  payload: data,
});
